module.exports = __webpack_public_path__ + "media/images/bg-home-tab-9bd99590.gif";